import { ChangeDetectorRef, ViewRef } from '@angular/core';

export const asViewRef = (cdRef: ChangeDetectorRef) => <ViewRef>cdRef;

export const objectKeys = <T extends {}>(obj: T): (keyof T)[] => <(keyof T)[]>Object.keys(obj);
export const objectValues = <T, U extends keyof T>(obj: T) => <T[U][]>(<unknown>Object.values(obj));
